import axios from 'axios';

class Api {
  constructor() {
    this.processing = false;
    this.limit = 10;
    this.search_url = '/product-search?query=';
    this.fuzzy_search_url = '/api/products/search';
  }

  search(query, type) {
    this.processing = true;

    let url = this.search_url + query;

    url = `${url}&limit=${this.limit}`;

    if (type) {
      url = `${url}&type=${type}`;
    }

    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(response => {
          this.processing = false;
          resolve(response.data);
        })
        .catch(error => {
          this.processing = false;
          reject(error.response);
        });
    });
  }

  fuzzySearch(search_text) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.fuzzy_search_url}?query=${search_text}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  }
}

export default Api;
